
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
@Injectable()
export class SearchPipe implements PipeTransform {
  transform(items: any[], field: string, value: string): any[] {
    if (!items) {
      return [];
    }
    if (!field || !value) {
      return items;
    }

    return items.filter(singleItem =>
      singleItem[field].toLowerCase().includes(value.toLowerCase())
    );
  }
}




@Pipe({
  name: 'filterBySettings'
})
@Injectable()
export class FilterBySettings implements PipeTransform {
  transform(items: any[], field: string): any[] {

   

    if (field=='' || field==undefined) {
      return items;
    }
 
    return items.filter(singleItem =>
                      singleItem.value.toLowerCase().includes(field.toLowerCase())
    );
  }
}

@Pipe({
  name: 'filterByReviewer'
})
@Injectable()
export class FilterByReviewer implements PipeTransform {
  transform(items: any[], field: string): any[] {

    

    if (field=='' || field==undefined) {
      return items;
    }
 
    return items.filter(singleItem =>
                      singleItem.name.toLowerCase().includes(field.toLowerCase())
    );
  }
}




@Pipe({
  name: 'filterByUser'
})
@Injectable()
export class FilterByUser implements PipeTransform {
  transform(items: any[], status: string , role: string ): any[] {

  
   // if ( (status=='' || status==undefined ) && (role=='' || role==undefined) ) {
      return items;
   // }

  }
}




@Pipe({
    name: 'highlight'
})
@Injectable()
export class highlight implements PipeTransform {

 
    transform(value: any, args: any): any {
      // console.log('value',value,'args',args)
      // console.log('value1',value.changingThisBreaksApplicationSecurity)
        if (!args) {return value;}
        var re = new RegExp(args, 'gi'); 
        // return value.replace(re, "<mark>$&</mark>");
        if(value.changingThisBreaksApplicationSecurity!=undefined){
          return value.changingThisBreaksApplicationSecurity.replace(re, "<mark>$&</mark>");
        }
       
    }
}